import gql from 'graphql-tag';
import { useQuery, useMutation } from '@vue/apollo-composable';

export const ARCHIVED_STUDENTS = gql`
  query ArchivedStudents($search: String, $page: Int, $per_page: Int) {
    archivedStudents(search: $search, page: $page, per_page: $per_page) {
      data {
        id
        student_id
        first_name
        surname
        other_name
        matric_no
        gender
        school_id
        school_name
        deleted_at
        transfer {
          target_school_name
          target_matric_no
          transferred_at
          reason
        }
      }
      total
      current_page
      per_page
    }
  }
`;

export const RESTORE_STUDENT = gql`
  mutation RestoreStudent($student_id: ID!) {
    restoreStudent(student_id: $student_id) {
      success
      message
    }
  }
`;

export const PERMANENTLY_DELETE_STUDENT = gql`
  mutation PermanentlyDeleteStudent($student_id: ID!) {
    permanentlyDeleteStudent(student_id: $student_id) {
      success
      message
    }
  }
`;

export const useArchivedStudents = () => useQuery(ARCHIVED_STUDENTS, { page: 1, per_page: 20 }, { fetchPolicy: 'network-only' });
